import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiService } from "./api.service";
import { Response } from 'src/app/shared/models/response.model';
import { DataWithPage } from 'src/app/shared/models/data-with-page.model';
import { GeneralCategory } from "src/app/shared/models/general-category.model";


const API_GET_ALL_CATEGORY = "/master-data-types/get-all";
const API_DELETE_CATEGORY = "/master-data-types/delete/";
const API_GET_CATEGORY_BY_ID = "/master-data-types/get-by-id/";
const API_CREATE_CATEGORY = "/master-data-types/create";
const API_UPDATE_CATEGORY = "/master-data-types/update";
const API_GET_ALL_PARENT = "/master-data-types/get-all-parents";
//api for admin
const API_SYSTEM_GET_ALL_CATEGORY = "/system-master-data-types/get-all";
const API_SYSTEM_DELETE_CATEGORY = "/system-master-data-types/delete/";
const API_SYSTEM_GET_CATEGORY_BY_ID = "/system-master-data-types/get-by-id/";
const API_SYSTEM_CREATE_CATEGORY = "/system-master-data-types/create";
const API_SYSTEM_UPDATE_CATEGORY = "/system-master-data-types/update";
const API_SYSTEM_GET_ALL_PARENT = "/system-master-data-types/get-all-parents";


@Injectable({
  providedIn: "root",
})
export class MasterDataTypeService {
  constructor(private apiService: ApiService) {}

  getCategory(body: any = {}): Observable<Response<DataWithPage<Array<GeneralCategory>>>> {
    return this.apiService.post(API_GET_ALL_CATEGORY, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getParent(body: any = {}): Observable<Response<DataWithPage<Array<GeneralCategory>>>> {
    return this.apiService.post(API_GET_ALL_PARENT, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  createCategory(body: any = {}): Observable<any> {
    return this.apiService.post(API_CREATE_CATEGORY, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  updateCategory(body: any = {}): Observable<any> {
    return this.apiService.post(API_UPDATE_CATEGORY, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  deleteCategory(id: string): Observable<Response<string>> {
    return this.apiService.get(`${API_DELETE_CATEGORY}${id}`).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getCategoryById(id: string): Observable<Response<GeneralCategory>> {
    return this.apiService.get(`${API_GET_CATEGORY_BY_ID}${id}`).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getSystemCategory(body: any = {}): Observable<Response<DataWithPage<Array<GeneralCategory>>>> {
    return this.apiService.post(API_SYSTEM_GET_ALL_CATEGORY, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getSystemParent(body: any = {}): Observable<Response<DataWithPage<Array<GeneralCategory>>>> {
    return this.apiService.post(API_SYSTEM_GET_ALL_PARENT, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  createSystemCategory(body: any = {}): Observable<any> {
    return this.apiService.post(API_SYSTEM_CREATE_CATEGORY, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  updateSystemCategory(body: any = {}): Observable<any> {
    return this.apiService.post(API_SYSTEM_UPDATE_CATEGORY, body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  deleteSystemCategory(id: string): Observable<Response<string>> {
    return this.apiService.get(`${API_SYSTEM_DELETE_CATEGORY}${id}`).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getSystemCategoryById(id: string): Observable<Response<GeneralCategory>> {
    return this.apiService.get(`${API_SYSTEM_GET_CATEGORY_BY_ID}${id}`).pipe(
      map((res) => {
        return res;
      })
    );
  }
}
